import { useTranslation } from "react-i18next"
import Card from "../ui-elements/Card"
import { GlobalContext } from '../GlobalContext'
import { useContext } from "react"
import RedAlert from "../ui-elements/RedAlert"
import FormatQuestionTitle from "./FormatQuestionTitle"

type Props = {
    thisCheckPeriod: ObjectStringKeyAnyValue
}


export default function NotesForCheckPeriod({ thisCheckPeriod }: Props) {

    const { t } = useTranslation()
    const { tableData } = useContext(GlobalContext)
    const checkPeriodNotes = thisCheckPeriod && thisCheckPeriod.notesForCheckPeriod ? thisCheckPeriod.notesForCheckPeriod : []
    const numberOfNotes = checkPeriodNotes.length || 0

    if (!checkPeriodNotes || checkPeriodNotes.length === 0) {
        return null
    }
 
    return <div className={`w-full rounded border bg-yellow-100 border-yellow-500 text-yellow-700 flex flex-col py-1 px-2`}>


        <p className={`font-bold text-lg`}>{t('Dashboard.NotesForCheckPeriod.notes', { count: numberOfNotes })}</p>


        {checkPeriodNotes.map((note: any, index: number) => {
            const questionId = note.QuestionId
            const question = questionId && tableData && tableData.ChecklistQuestions && tableData.ChecklistQuestions[questionId]

            return <div key={index} className={`w-full flex flex-row gap-1 items-center justify-start`}> 
                <FormatQuestionTitle
                    question={question}
                    classString={``}
                /> :
                <p className={`italic`}>{note.AnswerNote}</p>
            </div>
        })}


    </div>
}